import { PublicLayout } from "@/components/layout/PublicLayout";
import { GlassCard } from "@/components/GlassCard";
import { Reveal, SectionKicker } from "@/components/Reveal";
import SEO from "@/components/SEO";
import { container } from "@/lib/constants";

const SECTORS = [
  {
    name: "European Real Estate",
    overview:
      "Core, core-plus, and value-add opportunities across commercial, residential, and mixed-use assets in primary and select secondary European markets. We source repositioning, sale-and-leaseback, and forward-funding structures with certainty of execution.",
    types: ["Commercial repositioning", "Residential & PRS", "Mixed-use regeneration", "Sale-and-leaseback", "Forward funding"],
  },
  {
    name: "Private Credit",
    overview:
      "Direct lending and structured credit for mid-market operators, with conservative leverage and robust security. We arrange bilateral facilities and participations for principals seeking floating-rate exposure with downside protection.",
    types: ["Senior secured direct lending", "Unitranche", "Mezzanine", "Structured & asset-backed credit", "Bespoke facilities"],
  },
  {
    name: "Real Assets",
    overview:
      "Infrastructure, the energy transition, and agriculture — assets underpinned by contracted revenues and inflation linkage. We introduce co-investments alongside specialist managers and direct opportunities for larger mandates.",
    types: ["Infrastructure equity", "Energy transition & storage", "Renewables", "Agriculture & farmland", "Regulated assets"],
  },
  {
    name: "Late-Stage Equity",
    overview:
      "Pre-IPO and growth rounds in category-leading, capital-efficient businesses. We facilitate discreet primary and secondary access ahead of contemplated liquidity events.",
    types: ["Pre-IPO secondaries", "Growth primaries", "Structured equity", "Founder & employee liquidity", "Cornerstone allocations"],
  },
];

export default function Sectors() {
  return (
    <PublicLayout>
      <SEO title="Sectors" description="European Real Estate, Private Credit, Real Assets, and Late-Stage Equity — the four sectors Prime Deal Gateway sources within." />
      <section className={`${container} py-20 lg:py-24`}>
        <Reveal>
          <SectionKicker>Where we operate</SectionKicker>
          <h1 className="pdg-serif text-4xl sm:text-5xl text-foreground max-w-3xl leading-[1.08]">Sectors</h1>
          <p className="mt-6 text-lg text-foreground/80 max-w-2xl leading-8">
            We concentrate on four sectors where discretion and relationships create genuine access.
          </p>
        </Reveal>
        <div className="mt-14 space-y-6">
          {SECTORS.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.04}>
              <GlassCard data-testid="sector-card" className="p-8 lg:p-10">
                <div className="grid gap-8 lg:grid-cols-12">
                  <div className="lg:col-span-7">
                    <h2 className="pdg-serif text-2xl sm:text-3xl text-foreground">{s.name}</h2>
                    <p className="mt-4 text-sm text-muted-foreground leading-7 max-w-xl">{s.overview}</p>
                  </div>
                  <div className="lg:col-span-5">
                    <div className="pdg-kicker mb-4">Deal types we source</div>
                    <ul className="space-y-2">
                      {s.types.map((t) => (
                        <li key={t} className="flex items-center gap-3 text-sm text-foreground/80">
                          <span className="w-1 h-1 rounded-full bg-[hsl(var(--pdg-gold))]" />{t}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </GlassCard>
            </Reveal>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
